import {
  listWorkflows as publicListWorkflows,
  getWorkflow as publicGetWorkflow,
  updateWorkflow as publicUpdateWorkflow,
  createWorkflow as publicCreateWorkflow,
  deleteWorkflow as publicDeleteWorkflow,
} from './workflows-v1-workflow-workflows.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const listWorkflows: MaybeContext<
  BuildRESTFunction<typeof publicListWorkflows> & typeof publicListWorkflows
> = /*#__PURE__*/ createRESTModule(publicListWorkflows);
export const getWorkflow: MaybeContext<
  BuildRESTFunction<typeof publicGetWorkflow> & typeof publicGetWorkflow
> = /*#__PURE__*/ createRESTModule(publicGetWorkflow);
export const updateWorkflow: MaybeContext<
  BuildRESTFunction<typeof publicUpdateWorkflow> & typeof publicUpdateWorkflow
> = /*#__PURE__*/ createRESTModule(publicUpdateWorkflow);
export const createWorkflow: MaybeContext<
  BuildRESTFunction<typeof publicCreateWorkflow> & typeof publicCreateWorkflow
> = /*#__PURE__*/ createRESTModule(publicCreateWorkflow);
export const deleteWorkflow: MaybeContext<
  BuildRESTFunction<typeof publicDeleteWorkflow> & typeof publicDeleteWorkflow
> = /*#__PURE__*/ createRESTModule(publicDeleteWorkflow);

export {
  AttachmentType,
  SortOrder,
} from './workflows-v1-workflow-workflows.universal.js';
export {
  Workflow,
  WorkflowInfo,
  Phase,
  PhaseInfo,
  CardsList,
  Card,
  CardInfo,
  Attachment,
  PhasesList,
  ListWorkflowsRequest,
  ListWorkflowsResponse,
  PaginationResponse,
  QueryWorkflowsRequest,
  Query,
  Sorting,
  Paging,
  QueryWorkflowsResponse,
  GetWorkflowRequest,
  GetWorkflowResponse,
  UpdateWorkflowRequest,
  UpdateWorkflowResponse,
  CreateWorkflowRequest,
  CreateWorkflowResponse,
  DeleteWorkflowRequest,
  DeleteWorkflowResponse,
  SetupWorkflowRequest,
  SetupWorkflowResponse,
  ListWorkflowsOptions,
} from './workflows-v1-workflow-workflows.universal.js';
export {
  AttachmentTypeWithLiterals,
  SortOrderWithLiterals,
} from './workflows-v1-workflow-workflows.universal.js';
